



import React from "react";

import { Header } from '../../Components/Layout/Header.jsx'

export class InfoPranjeNovca extends React.Component {


    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
    }
    render() {
        return <div>
            <Header key="header" {...this.state} {...this.props} detailsHeader="true" headerText="Obavijest" headerBackUrl={this.props.getHomePathFn(this.props.route.location)}></Header>

            <div id="page-wrapper" className="white padding-2p-on-mobile border-on-tablet margin-1p-on-tablet">
                <h1 className="margin-bottom mobile-hidden">Obavijest igračima</h1>
                <div className="padding-sides-medium text-justify">

                    Poštovani,
                    <br /><br />
                    dana 01.01.2018. godine na snagu stupa <b>novi „Zakon o sprječavanju pranja novca i financiranja terorizma (NN 108/17)“</b>.
                    <br /><br />
                    Navedenim Zakonom nametnuta nam je obveza prilikom svake <b>uplate uloga i/ili isplate dobitka u iznosu od 15.000,00 kn i većem</b>,  prikupiti određene osobne
                    podatke.
                    <br /><br />
                    Slijedom navedenog, obavještavamo Vas da ste po Zakonu obvezni prilikom uplate ili isplate gore navedenog ili većeg iznosa dati na uvid Vašu osobnu iskaznicu i podatke propisane Zakonom.
                    <br /><br />
                    Ukoliko odbijete dati traženo, primorani  smo odbiti Vašu uplatu i/ili isplatu, te o odbijanju obavijestiti Ured za sprječavanje pranja novca.
                    <br /><br />
                    Također, sukladno navedenom zakonu obvezni smo tražiti  dodatne podatke <b>i kod registracije novih igrača</b>, te nadopuniti podatke za <b>već registrirane igrače</b>.
                    <br /><br />
                    Unaprijed se zahvaljujemo na razumijevanju, a u slučaju bilo kakvih pitanja ili nejasnoća možete se obratiti  djelatnicima u poslovnicama ili na e-mail ssport@supersport.hr

                    <br /><br />
                    Vaš SuperSport
                    <br /><br />

                </div>
            </div>
        </div>

    }
};
